import React, { useEffect, useRef, useState } from "react";
import {
  Box,
  Input,
  Button,
  VStack,
  HStack,
  Text,
  Avatar,
  useToast,
  Flex,
  Spacer,
  Card,
  CardBody,
} from "@chakra-ui/react";
import { FaPaperPlane } from "react-icons/fa";
import api from "../utils/axios";

const ChatBot = () => {
  const [messages, setMessages] = useState([{ role: "assistant", content: "Hey!" }]);
  const [input, setInput] = useState("");
  const toast = useToast();
  const messagesEndRef = useRef(null);

 // Automatsko skrolovanje na dno kad se promijene poruke
 useEffect(() => {
    // Provjeravamo da li referenca postoji i ako da, pozivamo scrollIntoView
    if (messagesEndRef.current) {
      messagesEndRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [messages]); // Ovaj useEffect se pokreće kad god se promijene poruke

  const sendMessage = async () => {
    if (!input.trim()) return;

    // Add user message to chat history
    const newMessages = [...messages, { role: "user", content: input }];
    setMessages(newMessages);
    setInput(""); // Clear input field

    try {
        var response = await api.post(`/chatbot/ask`, 
            { question: input }, // Pass the data as the second argument
            { headers: { "Content-Type": "application/json" } }
          );

        const data = response.data;

        // Assuming the AI's response is within `choices[0].message.content`
        const aiResponse = data.choices[0].message.content;

        // Add assistant message to chat
        setMessages([
          ...newMessages,
          { role: "assistant", content: aiResponse },
        ]);
    } catch (error) {
      console.error("Error:", error);
      toast({
        title: "Error",
        description: "There was an error with the request.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
  };

    // Function to handle key press event (for Enter key)
    const handleKeyDown = (event) => {
        if (event.key === "Enter") {
            sendMessage();
        }
        };

  return (
    <Box
      as="main"
      pt={{ base: "24px", md: "20px" }}
      pl={{ base: "0px", md: "240px" }}
      pr={{ base: "0px", md: "30px" }}
      pb="20px"
      minH="100vh"
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      bg="gray.50"
    >
      <Card width="100%" maxWidth="600px" borderRadius="md" shadow="lg">
        <CardBody p={4}>
          <VStack align="stretch" spacing={4}>
            <Text fontSize="2xl" fontWeight="bold" textAlign="center">
              Nautika Restaurant Chat
            </Text>
            <Box
              height="400px"
              overflowY="auto"
              border="1px solid"
              borderColor="gray.200"
              borderRadius="md"
              bg="white"
              p={2}
            >
              {messages.map((msg, index) => (
                <HStack
                  key={index}
                  spacing={4}
                  justify={msg.role === "user" ? "flex-end" : "flex-start"}
                >
                  {msg.role !== "user" && (
                    <Avatar size="sm" name="Nautika Bot" />
                  )}
                  <Box
                    maxWidth="70%"
                    p={2}
                    bg={msg.role === "user" ? "blue.500" : "gray.100"}
                    color={msg.role === "user" ? "white" : "black"}
                    borderRadius="lg"
                    m={2}
                    shadow="sm"
                  >
                    <Text>{msg.content}</Text>
                  </Box>
                  {msg.role === "user" && <Spacer />}
                </HStack>
              ))}
              {/* Dno chat-a - referenca */}
              <div ref={messagesEndRef} />
            </Box>

            <HStack spacing={2}>
              <Input
                placeholder="Ask a question..."
                value={input}
                onChange={(e) => setInput(e.target.value)}
                size="md"
                flex="1"
                variant="outline"
                onKeyDown={handleKeyDown}
              />
              <Button
                colorScheme="blue"
                onClick={sendMessage}
                rightIcon={<FaPaperPlane />}
              >
                Send
              </Button>
            </HStack>
          </VStack>
        </CardBody>
      </Card>
    </Box>
  );
};

export default ChatBot;
